<template>
    <div>
        <div class="main">
            <div class="title">
                订单
                <div @click="back" class="back">
                    <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                </div>
            </div>

        </div>

        <div class="content">
            <div class="nav">
                <div @click="getCurrentIndex(index)" v-for="(item , index) in navList" :key="index"
                     :class="[currentIndex == index ? 'active' : '','nav_item']">
                    {{item}}
                </div>
            </div>

            <!-- 未支付订单 -->
            <div v-show="currentIndex === 0">
                <orderList ref="allOrderList" :params="unpayParams"/>
            </div>

            <!-- 完成订单 -->
            <div v-show="currentIndex === 1">
                <orderList ref="closedOrderList" :params="closedParams"/>
            </div>

            <!-- 取消订单 -->
            <div v-show="currentIndex === 2">
                <orderList ref="cancelledOrderList" :params="cancelledParams"/>
            </div>
        </div>

        <!-- <div class="conversion_btn">
            兑换优惠券
        </div> -->

    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import orderBizTypeEnum from '@data/orderBizTypeEnum';
import orderStatusEnum from '@data/orderStatusEnum';

// config
import appConfig from '../../appConfig';

// modules
import orderList from './myOrderComp/orderList';

// util
import appHelper from '@util/appHelper';

import {toDetailByBizType} from '@comp/shixunApp/toDetail';

const config = {
    apiConfig: {
        // list: {
        //     url: '/portal/v4/user/center/getOrderList',
        //     dataPath: 'data.records',
        //     totalPath: 'data.total',
        //     totalPagePath: 'data.pages'
        // }
    }
};


export default {
    name: "orderForm",
    extends : shixunPagePart,
    components : { orderList },
    data() {
        return {
            currentIndex: 0,
            navList: ['待支付', '已完成', '已取消'],
            enableDataList: true,
            apiConfig: config.apiConfig,
            title: '我的订单',

            toDetailByBizType: toDetailByBizType,

            orderBizTypeEnum : orderBizTypeEnum,
            orderStatusEnum : orderStatusEnum,

            unpayParams : {
                orderStatus : orderStatusEnum.UNPAY.id
            },
            closedParams : {
                orderStatus : orderStatusEnum.PAID.id
            },
            cancelledParams : {
                orderStatus : orderStatusEnum.CLOSED.id
            }
        }
    },
    methods: {

        /**
         * @override
         */
        loadNextPage() {

            if (this.currentIndex === 0)
            {
                typeof(this.$refs.allOrderList) === 'undefined' ? null : this.$refs.allOrderList.loadNextPage();
            }
            else if (this.currentIndex === 1)
            {
                typeof(this.$refs.closedOrderList) === 'undefined' ? null : this.$refs.closedOrderList.loadNextPage();
            }
            else if (this.currentIndex === 2)
            {
                typeof(this.$refs.cancelledOrderList) === 'undefined' ? null : this.$refs.cancelledOrderList.loadNextPage();
            }

        },

        back() {
            appHelper.back(this)
        },
        getCurrentIndex(index) {
            this.currentIndex = index
            // if (index === 0) {
            //     this.apiConfig.list.params = {}
            //     this.reloadDataList();
            // } else if (index === 1) {
            //     //已完成传orderStatus = 2
            //     this.apiConfig.list.params.orderStatus = 2
            //     this.reloadDataList();
            // } else {
            //     //已取消传orderStatus = 9
            //     this.apiConfig.list.params.orderStatus = 9
            //     this.reloadDataList()
            // }

        },

        formatDateDetail(timer) {
            let time = new Date(timer)
            let Y = time.getFullYear();
            let M = time.getMonth() + 1;
            M = M < 10 ? '0' + M : M;// 不够两位补充0
            let D = time.getDate();
            D = D < 10 ? '0' + D : D;
            let H = time.getHours();
            H = H < 10 ? '0' + H : H;
            let Mi = time.getMinutes();
            Mi = Mi < 10 ? '0' + Mi : Mi;
            let S = time.getSeconds();
            S = S < 10 ? '0' + S : S;
            return Y + '-' + M + '-' + D + ' ' + H + ':' + Mi + ':' + S;
        }

    }
}
</script>
<style lang="scss" scoped>
.main {
    padding: 0 4%;
    box-sizing: border-box;
    background: #fff;
}

.title {
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 20px;

    font-weight: 600;
    color: #333333;

    overflow: hidden;
    padding-bottom: 10px;

}

.back {
    float: left;
    margin-top: 4px;
}


.nav {
    display: flex;
    height: 44px;
    background: #fff;
    // margin-bottom: 6px;
    .nav_item {
        flex: 1;
        height: 100%;
        line-height: 44px;
        text-align: center;
        font-size: 16px;

        font-weight: 400;
        color: #999999;

    }
    .active {
        font-size: 16px;

        font-weight: 400;
        color: #333333;

        position: relative;

    }
    .active::after {
        content: '';
        display: block;
        // background: red;

        background: #FFA724;
        width: 17px;
        height: 2px;
        position: absolute;
        bottom: 4px;
        left: 50%;
        transform: translateX(-50%);
    }
}

.order_item {
    width: 90%;
    // height: 172px;
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 12px;
    background: #fff;
    padding: 12px;
    padding-top: 8px;
    box-sizing: border-box;


}

.model_top {
    height: 17px;
    line-height: 17px;
    overflow: hidden;
}

.model_center {
    background: #F6F6F6;

    border-radius: 4px;
    margin-top: 13px;
    margin-bottom: 8px;
    box-sizing: border-box;
    padding: 8px;
    display: flex;
}

.center_img {
    width: 74px;
    height: 48px;
    border-radius: 4px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }
}

.center_right {
    flex: 1;
    margin-left: 8px;
    .right_title {

        font-size: 14px;

        font-weight: 400;
        color: #333333;

    }
}


.model_bottom1 {
    width: 100%;
    height: 17px;
    overflow: hidden;
    margin-bottom: 7px;

}

.model_bottom2 {
    width: 100%;
    height: 24px;
    line-height: 24px;
}

.btn {
    padding: 0px 7px;
    height: 24px;
    line-height: 20px;
    border-radius: 4px;
    box-sizing: border-box;

    font-size: 12px;

    font-weight: 600;
    color: #FFFFFF;

}

.fn {

    font-size: 12px;


    font-weight: 400;
    // font-weight: bolder;
    color: #999999;

}


.noList_style {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 261px;
        height: 210px;
    }
}


</style>
